<template>
    <navbar />
    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
  
      <sidebar />
  
      <div class="main-panel">
        <div class="content-wrapper">
          <div class="row">
            <div class="col-lg-12 grid-margin stretch-card px-0">
              <div class="card">
                <div class="card-body">
                  <div class="row col-md-9 mb-4">
                    <div class="d-flex flex-wrap gap-3">
                      <button class="btn text-white py-2 px-4" style="background-color: #007bff; border-radius: 6%;" data-bs-toggle="modal" data-bs-target="#addModal">Add New Nirmal Sathi</button>
                    </div>
                  </div>

                  <!-- <div class="row mb-3 align-items-center">
                      <div class="col-md-6">
                          <div class="d-flex align-items-center">
                              <label for="entriesSelect" class="me-2">Show</label>
                              <select id="entriesSelect" class="form-select-sm w-auto">
                                  <option value="10">10</option>
                                  <option value="25">25</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                              </select>
                              <span class="ms-2">entries</span>
                          </div>
                      </div>
                      <div class="col-md-6 d-flex align-items-center justify-content-end">
                          <label for="searchInput" class="me-2 form-label mb-0">Search:</label>
                          <input id="searchInput" type="text" class="form-control form-control-sm w-auto">
                      </div>
                  </div> -->
                  <div class="table-responsive">
                    <table class="table table-striped table-borderless">
                      <thead style="border-top: 1px solid grey; border-bottom: 1px solid grey;">
                        <tr>
                          <th>Sl No.</th>
                          <th>Name</th>
                          <th>Mobile No</th>
                          <th>User Id</th>
                          <th>Ward Name</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody v-if="nirmalSathiList != null">
                        <tr v-for="(data, index) in nirmalSathiList" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td class="font-weight-bold"><strong>{{ data.name }}</strong></td>
                          <td>{{ data.mobileNo }}</td>
                          <td>{{ data.userName }}</td>
                          <td>{{ data.get_ward.name }}</td>
                          <td>
                              <div class="dropdown">
                              <a href="#" class="text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                                  <i class="fa-solid fa-gear fa-lg" style="color: #63452c;"></i>                            </a>
                                  <ul class="dropdown-menu">
                                      <li><button class="dropdown-item" data-bs-toggle="modal" :data-bs-target="'#edit-nirmalSathi'+index" @click="editNirmalSathi(data.id)">Edit</button></li>
                                      <li><a class="dropdown-item" href="#">Delete</a></li>
                                  </ul>
                              </div>
                               <!-- Edit NirmalSathi modal -->
                              <div class="modal fade" :id="'edit-nirmalSathi'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                  <div class="modal-dialog custom-md-model"> <!-- Apply the custom class here -->
                                    <form class="form" @submit.prevent="updateNirmalSathi(data.id,index)">
                                      <div class="modal-content">
                                      
                                      <!-- Modal Header -->
                                      <div class="modal-header">
                                          <h5 class="modal-title" id="exampleModalLabel">Edit NirmalSathi Form ({{ data.name }} )</h5>
                                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                      </div>
                                      
                                      <!-- Modal Body -->
                                      <div class="modal-body px-4">
                                        <div class="row">
                                          <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Ward:</label>
                                            <select class="form-select form-select-sm" v-model="nirmalSathiForm.wardId" >
                                              <option selected disabled>Select Ward</option>
                                              <option v-for="ward in wardList" :key="ward.id" :value="ward.id" class="color-mg">
                                                {{ward.name}}
                                              </option>
                                            </select>
                                          </div>
                                          <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Name of Nirmal Sathai :</label>
                                            <input type="text" class="form-control form-control-sm" v-model="nirmalSathiForm.name">
                                          </div>
                                          <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Contact No :</label>
                                            <input type="text" class="form-control form-control-sm"  v-model="nirmalSathiForm.mobileNo">
                                          </div>
                                          <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">User Id :</label>
                                            <input type="text" class="form-control form-control-sm" readonly  :value="nirmalSathiForm.mobileNo">
                                          </div>
                                          <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Password :</label>
                                            <input type="text" class="form-control form-control-sm"  v-model="nirmalSathiForm.password">
                                          </div>
                                          <div class="col-md-6 form-group mb-3">
                                            <label class="form-label fw-bold">Confirmed Password :</label>
                                            <input type="text" class="form-control form-control-sm"  v-model="nirmalSathiForm.confirmedPassword">
                                          </div>
                                        </div>
                                      </div>
                                      
                                      <!-- Modal Footer -->
                                      <div class="modal-footer">
                                        <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                                        <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;">Update</button>
                                      </div>
                                      
                                      </div>
                                    </form>
                                  </div>
                              </div>
                          </td>
  
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="13" style="text-align: center; font-size: 18px;color: #de0723;">No Data Found !</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="p-2" v-if="this.searchPagination == false">
                        <pagination v-if="pagination.last_page > 1" 
                        :pagination="pagination" 
                        :offset="10" 
                        @paginate="getNirmalSathis()">
                        </pagination>
                    </div>
                    <!-- <div v-else>
                        <pagination v-if="pagination.last_page > 1" 
                        :pagination="pagination" 
                        :offset="10" 
                        @paginate="searchCitizen()">
                        </pagination>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          
        </div>
        <!-- content-wrapper ends -->
        <!-- partial:partials/_footer.html -->
        <footer class="footer">
          <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023. Premium <a href="" target="_blank"></a> All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"></span>
          </div>
        </footer>
        <!-- partial -->
      </div>
  
      <!-- Add New Nirmal Sathi modal -->
      <div class="modal fade" id="addModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog custom-md-model"> <!-- Apply the custom class here -->
            <form class="form" @submit.prevent="addNirmalSathi()">
              <div class="modal-content">
              
              <!-- Modal Header -->
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">New Nirmal Sathi</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <!-- Modal Body -->
              <div class="modal-body px-4">
                <div class="row">
                    <div class="col-md-6 form-group mb-3">
                      <label class="form-label fw-bold">Ward:</label>
                      <select class="form-select form-select-sm" v-model="nirmalSathiForm.wardId" >
                        <option selected disabled>Select Ward</option>
                        <option v-for="ward in wardList" :key="ward.id" :value="ward.id" class="color-mg">
                          {{ward.name}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 form-group mb-3">
                        <label class="form-label fw-bold">Name of Nirmal Sathai :</label>
                        <input type="text" class="form-control form-control-sm" v-model="nirmalSathiForm.name">
                    </div>
                    <div class="col-md-6 form-group mb-3">
                        <label class="form-label fw-bold">Contact No :</label>
                        <input type="text" class="form-control form-control-sm"  v-model="nirmalSathiForm.mobileNo">
                    </div>
                    <div class="col-md-6 form-group mb-3">
                        <label class="form-label fw-bold">User Id :</label>
                        <input type="text" class="form-control form-control-sm" disabled   :value="nirmalSathiForm.mobileNo">
                    </div>
                    <div class="col-md-6 form-group mb-3">
                        <label class="form-label fw-bold">Password :</label>
                        <input type="text" class="form-control form-control-sm"  v-model="nirmalSathiForm.password">
                    </div>
                    <div class="col-md-6 form-group mb-3">
                        <label class="form-label fw-bold">Confirmed Password :</label>
                        <input type="text" class="form-control form-control-sm"  v-model="nirmalSathiForm.confirmedPassword">
                    </div>
                </div>
              </div>
              
              <!-- Modal Footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Cancel</button>
                <button type="submit" class="btn btn-success text-white py-2" style="border-radius: 6%;">Save</button>
              </div>
              
              </div>
            </form>
          </div>
      </div>
  
     
      <!-- Search Modal -->
      <!-- <div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog custom-small-modal"> 
              <div class="modal-content">
          
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Import Citizen Form</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              
              <div class="modal-body px-4">
                  <form>
                  <div class="form-group mb-3">
                  <label class="form-label fw-bold">Ward:</label>
                  <select class="form-select form-select-sm">
                      <option selected disabled>Select Ward</option>
                      <option value="1">Ward 1</option>
                      <option value="2">Ward 2</option>
                      <option value="3">Ward 3</option>
                  </select>
                  </div>
                  <div class="form-group mb-3">
                  <label class="form-label fw-bold">Road:</label>
                  <select class="form-select form-select-sm">
                      <option selected disabled>Select Road</option>
                      <option value="A">Road A</option>
                      <option value="B">Road B</option>
                      <option value="C">Road C</option>
                  </select>
                  </div>
                  <div class="form-group mb-3">
                  <label class="form-label fw-bold">Block:</label>
                  <select class="form-select form-select-sm">
                      <option selected disabled>Select Block</option>
                      <option value="X">Block X</option>
                      <option value="Y">Block Y</option>
                      <option value="Z">Block Z</option>
                  </select>
                  </div>
                  </form>
              </div>
     
              <div class="modal-footer">
                  <button type="button" class="btn btn-danger text-white py-2" data-bs-dismiss="modal" style="border-radius: 6%;">Close</button>
                  <button type="button" class="btn btn-success text-white py-2" style="border-radius: 6%;">Search</button>
  
              </div>
              
              </div>
          </div>
      </div>  -->
  
  
      <!-- main-panel ends -->
    </div>
  </template>
  <script>
    import Navbar   from '../layouts/navbar.vue';
    import Sidebar  from '../layouts/sidebar.vue';
    import Api      from '../util/Api';
    import Chokidar from '../util/Chokidar';
    import Pagination   from '../util/Pagination.vue'
  
    export default {
      components: {
        navbar: Navbar,
        sidebar: Sidebar,
        pagination: Pagination
      },
      data() {
        return {
  
          isLoading : false,
  
          nirmalSathiForm:{
            name : "",
            mobileNo : "",
            userName : "",
            password : "",
            confirmedPassword : "",
            wardId: ""
          },
  
          wardList : [{}],
          roadList : [{}],
          blockList : [{}],
          nirmalSathiList : [{}],
  
          pagination: {
            current_page: 1,
          },
  
          isDisabledOne : true,
          isDisabledTwo : true,
          
          searchPagination : false,
  
          searchForm:{
            wardNo   : '',
            roadName : '',
            block    : ''
          }
  
        }
      },
  
      methods:{

        addNirmalSathi()
        {
          this.nirmalSathiForm.userName = this.nirmalSathiForm.mobileNo;
          Api().post('/add-nirmal-sathai',this.nirmalSathiForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              if(response.data['success'] == true)
              {
                this.getNirmalSathis();
                this.nirmalSathiForm ={
                  name : "",
                  mobileNo : "",
                  userName : "",
                  password : "",
                  confirmedPassword : "",
                };
                $('#addModal').modal('hide');
                this.$swal({
                    icon: 'success',
                    title: ' '+response.data['message'],
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 4000
                });
              }
            });
        },
  
        editNirmalSathi(id)
        {
          Api().get('/edit-nirmal-sathi/'+id)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/admin/login');
              } 
            }).then((response) => {
              if(response.data != '')
              { 
                this.nirmalSathiForm.name = response.data.data.name;
                this.nirmalSathiForm.mobileNo = response.data.data.mobileNo;
                this.nirmalSathiForm.address  = response.data.data.address;
                this.nirmalSathiForm.userName = response.data.data.userName;
                this.nirmalSathiForm.wardId   = response.data.data.get_ward.name;
              }
          });
        },
  
        updateCitizen(id,index)
        {
            Api().post('/update-nirmal-sathi/'+id,this.nirmalSathiForm)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              if(response.data['success'] == true)
              {
                this.getCitizens();
                this.nirmalSathiForm ={
                  name : "",
                  mobileNo : "",
                  userName : "",
                  password : "",
                  confirmedPassword : "",
                };
                $('#edit-nirmalSathi'+index).modal('hide');
                this.$swal({
                  icon: 'success',
                  title: ' '+response.data['message'],
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
              }
            });
        },
  
        getNirmalSathis()
        {
          this.isLoading = true;
          this.searchPagination = false;
          Api().get('/all-nirmal-sathi?page='+this.pagination.current_page)
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              console.log(response)
             
                this.isLoading = false;
                this.nirmalSathiList = response.data.data;
                this.pagination  = response.data.meta;
              
            });
        },

        getWard()
        {
          Api().get('/ward-list')
            .catch((error) => {
              if (error.response.status == 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('guard');
                this.$swal({
                  icon: 'error',
                  title: 'Session Expired, please login!',
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 4000
                });
                this.$router.push('/login');
              } 
            }).then(response =>{
              this.wardList = response.data.data;
            });
        },

        
  
      },
      created()
      {
        if(Chokidar() != 'user'){
          this.$router.push('/login');
        }else{
          this.getNirmalSathis();
          this.getWard();
        }
      }
    }
  </script>